import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageHandlerDirective } from './directives/image-handler.directive';
import { SafePipe } from './pipes/safe.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
  declarations: [SafePipe, ImageHandlerDirective, TruncatePipe],
  imports: [CommonModule],
  exports: [SafePipe, ImageHandlerDirective, TruncatePipe],
})
export class HelperModule {}
